import script from "./UiTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTable.vue?vue&type=script&setup=true&lang=js"

import "./UiTable.vue?vue&type=style&index=0&id=1be962c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be962c6"]])

export default __exports__